import { Component, OnInit, Input, ElementRef, Output, EventEmitter } from '@angular/core';
import { DashboardQueries } from '../../../../cp/shared/enums/DashboardQueries';
import { widgetFilters } from '../../../shared/enums/widgetFilters';

import { WidgetSearch } from '../../../shared/models/WidgetSearch';
import { DashboardService } from '../../../shared/services/dashboard.service';
import { GlobalsService } from '../../../shared/services/globals.service';

import { DashboardWidgetService } from '../../../shared/services/dashboardWidget.service';
//import { Item } from '@progress/kendo-angular-grid/dist/es2015/data/data.iterators';
import { filterItem } from '@app/cp/shared/models/filterItem';
import { WindowContents } from '@app/cp/shared/enums/windowContents';

@Component({
    selector: 'cp-zero-dollar-orders',
    templateUrl: './zero-dollar-orders.component.html',
    styleUrls: ['./zero-dollar-orders.component.scss']
})
export class ZeroDollarOrdersComponent implements OnInit {

    constructor(private svc_globals: GlobalsService, private svc_data: DashboardService, private svc_dashWidget: DashboardWidgetService, private el: ElementRef) { }

    @Input() chartType: string = 'donut';
    @Input() inputSearchParams: WidgetSearch;
    @Input() detailsTitleStart: string = '';
    @Output() loaderState = new EventEmitter<any>();
    @Output() loaderErrorState = new EventEmitter<any>();
    @Output() searchParams = new EventEmitter<WidgetSearch>(true);

    detailsTitle: string;
    detailsActive: boolean = false;
    selectedFilters: WidgetSearch;
    public windowData: any = {};
    public showDetails: boolean = false;
    public showWindow: boolean = false;
    public activeChildComp: number;
    public contentTypes = WindowContents;
    public dashboardQuery: DashboardQueries = DashboardQueries.zeroDollarOrders;

    widgetQuery: DashboardQueries = DashboardQueries.zeroDollarOrders;
    chartSearchFilters: widgetFilters[] = [widgetFilters.fiscalYear];

    show: boolean = false;
    searchParam: WidgetSearch;
    data: any;
    gridData: any;

    ngOnInit() {
        //this.search(this.searchParam);
    }

    search(searchParam: WidgetSearch) {
        this.searchParam = searchParam;
        this.searchParams.emit(searchParam);
        this.searchParam.userId = this.svc_globals.userId;
        this.showSpinner();
        this.svc_data.getDashboardQuery(this.widgetQuery, this.searchParam).subscribe(data => {
            this.data = data;
            this.gridData = data;
            if (data.error) {
                alert('got an error back!');
            }
            this.hideSpinner();
        });
    }

    showSpinner() {
        this.loaderState.emit(true);
       // $(this.el.nativeElement).closest('.cp-widget').find('.jarviswidget-loader').first().css('display', 'block');
    }

    hideSpinner() {
        this.loaderState.emit(false);
        //$(this.el.nativeElement).closest('.cp-widget').find('.jarviswidget-loader').css('display', 'none');
    }

    public onToggle(): void {
        this.show = !this.show;
    }

    setDetailData(category?: string) {
        this.showSpinner();
        let filter = new filterItem();
        filter.field = "Status";
        if (category) {
            filter.value = category;
            this.searchParam.out_S = filter.value;
            this.detailsTitle = this.detailsTitleStart + filter.value;
        }
        this.detailsActive = true;
        //this.createComponent(DisplayTarget.bottom, FactoryComponents.Dispatches, this.searchParam);
        //this.chartItemSelected.emit(filter);
        this.selectedFilters = this.searchParam;
        this.windowData.selectedFilters = this.selectedFilters;
        this.windowData.dashboardQuery = this.dashboardQuery;
        if (this.gridData) {
            this.windowData.gridData = this.gridData;
        }
        this.popWindow();
        this.hideSpinner();
    }

    popWindow() {
        this.activeChildComp = this.contentTypes.chartWidget;
        //this.windowData = {};
        this.showWindow = true;
        this.svc_data.disableDragging = true;
    }

    public onGridButtonClick() {
        this.showSpinner();
        this.setDetailData();
    }

    onClosed(e) {
        this.showWindow = false;
        this.svc_data.disableDragging = false;
    }

    public get animate(): any {
        //if (this.enabled) {
        //    return {
        //        type: this.type,
        //        direction: this.direction,
        //        duration: this.duration
        //    };
        //}

        return false;
    }

    setSearchParams(searchParams: WidgetSearch) {
        this.searchParams.emit(searchParams);
    }
}
